import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import { BiCloudDownload } from "react-icons/bi";
import { IoMdPrint } from "react-icons/io";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf'

function GenerateInvoice() {
  const input = document.querySelector("#invoiceCapture");
  const margin = 20;

  html2canvas(input, { scale: 2 }).then((canvas) => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'pt', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth() - 2 * margin; // Adjust width for margins;;
    const pdfHeight = pdf.internal.pageSize.getHeight() - 2 * margin; // Adjust height for margins;;

    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;

    const imgHeight = (canvasHeight * pdfWidth) / canvasWidth;
    let heightLeft = imgHeight;
    let position = margin;

    // Add the first page
    pdf.addImage(imgData, 'PNG', margin, position, pdfWidth, imgHeight);
    heightLeft -= pdfHeight;

    // Add more pages if content overflows
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      // position = margin - (imgHeight - heightLeft); //Recalculate position for next page
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', margin, position, pdfWidth, imgHeight);
      heightLeft -= pdfHeight;
    }

    pdf.save('invoice.pdf');
  });
}

const formatTextWithBoldFirstLineAndNewlines = (text) => {
  if (!text) return null;

  // Ensure text is a string
  const sanitizedText = String(text);

  const lines = sanitizedText.split('\n');
  return lines.map((line, index) => (
    <React.Fragment key={index}>
      {index === 0 ? <strong>{escapeHtml(line)}</strong> : escapeHtml(line)}
      <br />
    </React.Fragment>
  ));
};

const formatTextWithNewlines = (text) => {
  if (!text) { return null; }
  return text.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {escapeHtml(line)}
      <br />
    </React.Fragment>
  ));
};
function escapeHtml(unsafe) {
  return unsafe.replace(/[&<>"']/g, function (m) {
    switch (m) {
      case '&':
        return '&amp;';
      case '<':
        return '&lt;';
      case '>':
        return '&gt;';
      case '"':
        return '&quot;';
      case "'":
        return '&#039;';
      default:
        return m;
    }
  });
}

class InvoiceModal extends React.Component {
  constructor(props) {
    super(props);
  }
  handlePrint = () => {
    const printContents = document.getElementById('invoiceCapture').innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;

    window.print();

    document.body.innerHTML = originalContents;
  };

  render() {
    const { showModal, closeModal, info, items, currency } = this.props;
    return (
      <div>
        <Modal show={showModal} onHide={closeModal} size="lg" centered>
          <div id="invoiceCapture" className='main'> {/* Added main class for consistent styling */}
            <div className='left-pane'> {/* Added left-pane for consistent styling */}
              <div className="invoice-header"> {/* Added invoice-header for logo and invoice number */}
                <div className="logo">
                  {info.logo && <img src={info.logo} alt="Logo" style={{border:'1px', borderColor:'white', backgroundColor:'white'}} />}
                </div>
                <div className="invoice-info">
                  <label htmlFor="invoice-number">TAX INVOICE</label>
                  <span>{info.invoiceNumber}</span> {/* Display invoice number */}
                </div>
              </div>
              <div className="invoice-form flex">
                {/* Left Form */}
                <div className="left-form"> {/* w-1/2 and padding right */}
                  {info.billFromWhom && (
                    <div className="upper-column">
                      <div className=" w-full max-w-lg whitespace-pre-wrap break-words text-sm">
                        {formatTextWithBoldFirstLineAndNewlines(info.billFromWhom)}
                      </div>
                    </div>
                  )}
                  <div className="columns">
                    {info.billFrom && (
                      <div className="column">
                        <h3 className='col-heading' style={{fontWeight:'unset'}}>Bill To</h3>
                        <div className="text-content w-full max-w-lg whitespace-pre-wrap break-words text-sm">
                          {formatTextWithBoldFirstLineAndNewlines(info.billFrom)}
                        </div>
                      </div>
                    )}
                    {info.billTo && (
                      <div className="column">
                        <h3 className='col-heading' style={{fontWeight:'unset'}}>Ship To</h3>
                        <div className="text-content w-full max-w-lg whitespace-pre-wrap break-words text-sm">
                          {formatTextWithBoldFirstLineAndNewlines(info.billTo)}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Right Form */}
                <div className="right-form">

                  <Row className="justify-content-end">
                    <Col lg={11}>
                      {info.dateOfIssue && (
                        // <div className="flex justify-end items-center w-full max-w-md">
                        <div className="d-flex flex-row align-items-start justify-content-between">
                          <span className="fw-bold">Date:
                          </span>
                          <span>{info.dateOfIssue}</span>
                        </div>
                      )}
                      {info.paymentTerm && (
                        <div className="d-flex flex-row align-items-start justify-content-between">
                          <span className="fw-bold">Payment Term:
                          </span>
                          <span>{info.paymentTerm}</span>
                        </div>
                      )}
                      {info.dueDate && (
                        <div className="d-flex flex-row align-items-start justify-content-between">
                          <span className="fw-bold">Due Date:
                          </span>
                          <span>{info.dueDate}</span>
                        </div>
                      )}
                      {info.poNumber && (
                        <div className="d-flex flex-row align-items-start justify-content-between">
                          <span className="fw-bold">PO Number:
                          </span>
                          <span>{info.poNumber}</span>
                        </div>
                      )}
                    </Col>
                  </Row>
                </div>
              </div>

              <Table className='items-table'>
                <thead>
                  <tr>
                    <th className='bg-black text-white'>ITEM</th>
                    <th className='bg-black text-white'>QUANTITY</th>
                    <th className='bg-black text-white'>RATE</th>
                    <th className='bg-black text-white'>CGST%</th>
                    <th className='bg-black text-white'>SGST%</th>
                    <th className='bg-black text-white'>IGST%</th>
                    <th className='bg-black text-white'>AMOUNT</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item) => 
                  (
                    <tr key={item.id}>
                      <td>{item.name}</td>
                      <td>{item.quantity}</td>
                      <td>{currency}{parseFloat(item.price).toFixed(2)}</td>
                      <td>{item.cgst}%</td>
                      <td>{item.sgst}%</td>
                      <td>{item.igst}%</td>
                      <td>{currency}{parseFloat(item.amount).toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className='bottom-pane'>
                <div className='bottom-left-pane'>
                  {info.notes && ( // Conditional rendering for notes
                    <div className="notes-div">
                      <h3 className='bottom-pane-col-heading'>Notes</h3>
                      <div className="text-content w-full max-w-lg whitespace-pre-wrap break-words">
                        {formatTextWithNewlines(info.notes)}
                      </div>
                    </div>
                  )}
                  {info.terms && ( // Conditional rendering for terms
                    <div className="terms-div">
                      <h3 className='bottom-pane-col-heading'>Terms</h3>
                      <div className="text-content w-full max-w-lg whitespace-pre-wrap break-words">
                        {formatTextWithNewlines(info.terms)}
                      </div>
                    </div>
                  )}
                </div>
                <div className='bottom-right-pane'>
                  <Row className="mt-4 justify-content-end">
                    <Col lg={8}>
                      <div className="d-flex flex-row align-items-start justify-content-between">
                        <span className="fw-bold">Subtotal:</span>
                        <span>{currency} {parseFloat(info.subTotal).toFixed(2)}</span>
                      </div>
                      {parseFloat(info.discountAmmount) > 0 && (
                        <div className="d-flex flex-row align-items-start justify-content-between mt-2">
                          <span className="fw-bold">Discount:</span>
                          <span>
                            <span className="small ">({info.discountRate}%)</span>
                            {currency} {parseFloat(info.discountAmmount).toFixed(2)}</span>
                        </div>
                      )}
                      {parseFloat(info.cgstAmount) > 0 && (
                        <div className="d-flex flex-row align-items-start justify-content-between mt-2">
                          <span className="fw-bold">CGST:</span>
                          <span>
                          <span className="small ">({info.cgstAvgRate || 0}%)</span>
                          {currency} 
                          {parseFloat(info.cgstAmount).toFixed(2)}
                          </span>
                        </div>
                      )}
                      {parseFloat(info.sgstAmount) > 0 && (
                        <div className="d-flex flex-row align-items-start justify-content-between mt-2">
                          <span className="fw-bold">SGST:</span>
                          <span>
                          <span className="small ">({info.sgstRate || 0}%)</span>
                          {currency} {parseFloat(info.sgstAmount).toFixed(2)}</span>
                        </div>
                      )}
                      {parseFloat(info.igstAmount) > 0 && (
                        <div className="d-flex flex-row align-items-start justify-content-between mt-2">
                          <span className="fw-bold">IGST:</span>
                          <span>
                          <span className="small ">({info.igstRate || 0}%)</span>
                            {currency} {parseFloat(info.igstAmount).toFixed(2)}</span>
                        </div>
                      )}
                      {/* <div className="d-flex flex-row align-items-start justify-content-between mt-2">
                        <span className="fw-bold">GST:</span>
                        <span>{currency} {parseFloat(info.gstAmount).toFixed(2)}</span>
                      </div> */}
                      {parseFloat(info.shippingAmmount) > 0 && (
                        <div className="d-flex flex-row align-items-start justify-content-between mt-2">
                          <span className="fw-bold">Shipping:</span>
                          <span>{currency} {parseFloat(info.shippingAmmount).toFixed(2)}</span>
                        </div>
                      )}
                      {parseFloat(info.adjustment) !== 0 && (
                        <div className="d-flex flex-row align-items-start justify-content-between mt-2">
                          <span className="fw-bold">Adjustment:</span>
                          <span>{parseFloat(info.adjustment).toFixed(2)}</span>
                        </div>
                      )}
                      <hr />
                      <div className="d-flex flex-row align-items-start justify-content-between">
                        <span className="fw-bold">Total:</span>
                        <span className="fw-bold">{currency} {parseFloat(info.total).toFixed(2)}</span>
                      </div>
                      {parseFloat(info.amountPaid) > 0 && ( // Conditionally render if amountPaid > 0
                        <div className="d-flex flex-row align-items-start justify-content-between mt-2">
                          <span className="fw-bold">Amount Paid:</span>
                          <span>{currency} {parseFloat(info.amountPaid).toFixed(2)}</span>
                        </div>
                      )}

                      {/* Display Balance Due only if it's different from the total */}
                      {(parseFloat(info.amountPaid) > 0) && (
                        <div className="d-flex flex-row align-items-start justify-content-between mt-2">
                          <span className="fw-bold">Balance Due:</span>
                          <span>{currency} {parseFloat(info.balanceDue).toFixed(2)}</span>
                        </div>
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
              <div className="mt-5 p-2 w-1/3 authorized-signature">
                <div className="signature-space" style={{ height: '100px', borderBottom: '1px solid black', marginBottom: '5px' }}>
                  {/* Space for signature */}
                </div>
                <div className="signature-label" style={{ textAlign: 'center', fontSize: '13px', fontWeight: 'bold' }}>
                  Authorized Signature
                </div>
              </div>
            </div>
          </div>

          <div className="pb-4 px-4">
            <Row>
              <Col md={6}> {/* Adjust column size as needed */}
                <Button variant="primary" className="d-block w-100" onClick={this.handlePrint}>
                  <IoMdPrint style={{ width: '16px', height: '16px', marginTop: '-3px' }} className="me-2" />
                  Print
                </Button>
              </Col>
              <Col md={6}>
                <Button variant="outline-primary" className="d-block w-100 mt-3 mt-md-0" onClick={GenerateInvoice}>
                  <BiCloudDownload style={{ width: '16px', height: '16px', marginTop: '-3px' }} className="me-2" />
                  Download Copy
                </Button>
              </Col>
            </Row>
          </div>
        </Modal >
        <hr className="mt-4 mb-3" />
      </div >
    )
  }
}

export default InvoiceModal;